import styled, { keyframes } from 'styled-components';

const fadeInScale = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.3);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

const SvgWrapper = styled.svg`
  .star-1 {
    animation: ${fadeInScale} 0.6s ease-out forwards;
    animation-delay: .8s;
    transform-origin: center;
    opacity: 0;
  }

  .star-2 {
    animation: ${fadeInScale} 0.6s ease-out forwards;
    animation-delay: 1s;
    transform-origin: center;
    opacity: 0;
  }

  .star-3 {
    animation: ${fadeInScale} 0.6s ease-out forwards;
    animation-delay: 1.2s;
    transform-origin: center;
    opacity: 0;
  }

  .star-4 {
    animation: ${fadeInScale} 0.6s ease-out forwards;
    animation-delay: 1.4s;
    transform-origin: center;
    opacity: 0;
  }
`;

export const StarBand = ({ level = 1 }) => {
  const getStarColor = (starIndex) => {
    return starIndex <= level ? 'white' : '#CCAA33';
  };

  return (
    <SvgWrapper width="380" height="80" viewBox="0 0 380 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.75457 79.6885C4.71183 79.6929 3.04142 76.1495 4.9811 73.8052L20.5126 55.0335C21.4713 53.8749 21.6069 52.2418 20.8526 50.9409L3.1229 20.3628C1.73525 17.9696 3.45943 14.9718 6.22586 14.9677L98.245 14.8331C100.229 14.8302 101.84 16.4361 101.843 18.4202L101.936 75.9572C101.939 77.9417 100.332 79.553 98.348 79.5559L7.75457 79.6885Z" fill="#FFD440" />
      <path d="M102.405 79.6996L64.4087 64.0528L102.405 59.3113V79.6996Z" fill="#CCAA33" />
      <path d="M371.745 79.6885C374.788 79.6929 376.459 76.1495 374.519 73.8052L358.987 55.0335C358.029 53.8749 357.893 52.2418 358.647 50.9409L376.377 20.3628C377.765 17.9696 376.041 14.9718 373.274 14.9677L281.255 14.8331C279.271 14.8302 277.66 16.4361 277.657 18.4202L277.564 75.9572C277.561 77.9417 279.168 79.553 281.152 79.5559L371.745 79.6885Z" fill="#FFD440" />
      <path d="M277.095 79.6996L315.091 64.0528L277.095 59.3113V79.6996Z" fill="#CCAA33" />
      <rect x="63.9451" width="251.147" height="63.9451" rx="3.5929" fill="#FDEE7D" />
      <path className="star-1" d="M101.752 10.9266C102.731 8.11118 106.712 8.11118 107.691 10.9266L111.685 22.4159C111.747 22.5931 111.912 22.7129 112.1 22.7167L124.26 22.9647C127.24 23.0254 128.471 26.8123 126.096 28.6132L116.403 35.9618C116.253 36.0753 116.19 36.2704 116.244 36.4501L119.767 48.0917C120.63 50.9446 117.409 53.2852 114.962 51.5829L104.978 44.6356C104.824 44.5283 104.619 44.5283 104.465 44.6356L94.4807 51.5829C92.0341 53.2852 88.8129 50.9446 89.676 48.0917L93.1985 36.4501C93.2528 36.2704 93.1897 36.0753 93.0403 35.9618L83.3469 28.6132C80.972 26.8124 82.2022 23.0258 85.1819 22.9647L97.343 22.7167C97.5307 22.7129 97.6963 22.5931 97.7581 22.4159L101.752 10.9266Z" fill={getStarColor(1)} stroke="#CCAA33" strokeWidth="2.69467" />
      <path className="star-2" d="M157.357 10.9266C158.335 8.11118 162.317 8.11118 163.295 10.9266L167.289 22.4159C167.351 22.5931 167.517 22.7129 167.704 22.7167L179.865 22.9647C182.844 23.0254 184.075 26.8123 181.7 28.6132L172.007 35.9618C171.858 36.0753 171.795 36.2704 171.849 36.4501L175.371 48.0917C176.234 50.9446 173.013 53.2852 170.567 51.5829L160.582 44.6356C160.428 44.5283 160.224 44.5283 160.07 44.6356L150.085 51.5829C147.639 53.2852 144.417 50.9446 145.281 48.0917L148.803 36.4501C148.857 36.2704 148.794 36.0753 148.645 35.9618L138.951 28.6132C136.577 26.8124 137.807 23.0258 140.786 22.9647L152.948 22.7167C153.135 22.7129 153.301 22.5931 153.363 22.4159L157.357 10.9266Z" fill={getStarColor(2)} stroke="#CCAA33" strokeWidth="2.69467" />
      <path className="star-3" d="M212.961 10.9266C213.94 8.11118 217.921 8.11118 218.899 10.9266L222.894 22.4159C222.955 22.5931 223.121 22.7129 223.309 22.7167L235.469 22.9647C238.449 23.0254 239.68 26.8123 237.305 28.6132L227.611 35.9618C227.462 36.0753 227.399 36.2704 227.453 36.4501L230.976 48.0917C231.839 50.9446 228.618 53.2852 226.171 51.5829L216.187 44.6356C216.032 44.5283 215.828 44.5283 215.674 44.6356L205.689 51.5829C203.243 53.2852 200.022 50.9446 200.885 48.0917L204.407 36.4501C204.462 36.2704 204.398 36.0753 204.249 35.9618L194.556 28.6132C192.181 26.8124 193.411 23.0258 196.391 22.9647L208.552 22.7167C208.739 22.7129 208.905 22.5931 208.967 22.4159L212.961 10.9266Z" fill={getStarColor(3)} stroke="#CCAA33" strokeWidth="2.69467" />
      <path className="star-4" d="M268.565 10.9266C269.544 8.11118 273.525 8.11118 274.504 10.9266L278.498 22.4159C278.56 22.5931 278.725 22.7129 278.913 22.7167L291.073 22.9647C294.053 23.0254 295.284 26.8123 292.909 28.6132L283.216 35.9618C283.066 36.0753 283.003 36.2704 283.058 36.4501L286.58 48.0917C287.443 50.9446 284.222 53.2852 281.775 51.5829L271.791 44.6356C271.637 44.5283 271.433 44.5283 271.278 44.6356L261.294 51.5829C258.847 53.2852 255.626 50.9446 256.489 48.0917L260.012 36.4501C260.066 36.2704 260.003 36.0753 259.854 35.9618L250.16 28.6132C247.785 26.8124 249.015 23.0258 251.995 22.9647L264.156 22.7167C264.344 22.7129 264.51 22.5931 264.571 22.4159L268.565 10.9266Z" fill={getStarColor(4)} stroke="#CCAA33" strokeWidth="2.69467" />
    </SvgWrapper>

  )
}
